export const URLS = {
  // CONTACT_PAGE: "http://dev.site.keyspider.site/contact.php",
  CONTACT_PAGE: "http://keyspider.io/contact.php",
};
